var _ = require('lodash');
var React = require('react');
var Reflux = require('reflux');

var analytics = require('analytics');
var storyScenarios = require('models/storyScenarios');

var ScrollSpyContentsMixin = require('views/scrollSpy/ScrollSpyContentsMixin');

var SCROLLSPY_PROPS = {
  id: 'scenario-seed-value',
  name: 'Investors Assign Value'
}

module.exports = React.createClass({displayName: "module.exports",
  mixins: [
    ScrollSpyContentsMixin,
    Reflux.listenTo(actions.chart.selectMeasure, '_onSelectMeasure')
  ],

  getInitialState:function() {
    return {
      scrollSpy: SCROLLSPY_PROPS,
      lastMeasure: 'percentages'
    };
  },

  _onSelectMeasure: function(measure) {
    this.setState({
      lastMeasure: measure
    });
  },

  onScrollSpyFocus: function(target) {
    actions.ui.hideSelectRound(false);
    actions.ui.showPVScatter(false);
    actions.chart.setAxisLock(); // set axis lock here so enabled when it becomes visible next step (eg coming back to it)
    actions.chart.showFirstRoundLabels(true);
    actions.chart.selectMeasure('values');
    actions.round.setScenario(storyScenarios.rounds.seed);
    actions.chart.selectRound(storyScenarios.rounds.seed);
  },

  switchToPercentage:function() {
    analytics.event(
      analytics.E.ROUND_CHART_BUTTON.ID,
      analytics.E.ROUND_CHART_BUTTON.PERCENTAGE_VIEW,
      SCROLLSPY_PROPS.id
    );
    actions.chart.selectMeasure('percentages');
  },

  switchToValue:function() {
    analytics.event(
      analytics.E.ROUND_CHART_BUTTON.ID,
      analytics.E.ROUND_CHART_BUTTON.VALUE_VIEW,
      SCROLLSPY_PROPS.id
    );
    actions.chart.selectMeasure('values');
  },

  render:function() {
    return (
      React.createElement("div", {id: SCROLLSPY_PROPS.id}, 
        React.createElement("h1", {className: this.state.scrollSpy.isFocused ? 'focus' : ''}, "Investors Dilute but Assign Value"), 
        React.createElement("p", null, 
          "Instead of looking at ", React.createElement("a", {onClick: this.switchToPercentage, className: 'btn btn-xs ' + (this.state.lastMeasure === 'percentages' ? 'btn-primary' : 'btn-default')}, 
            React.createElement("i", {className: "fa fa-hand-o-right"}), " percentage"
          ), " ownership, we can look" + " " +
          "at the ", React.createElement("a", {onClick: this.switchToValue, className: 'btn btn-xs ' + (this.state.lastMeasure === 'percentages' ? 'btn-default' : 'btn-primary')}, 
            React.createElement("i", {className: "fa fa-hand-o-right"}), " value"
          ), " of your equity."
        ), 
        React.createElement("p", null, 
          "Note that ", React.createElement("strong", null, "your company had no value until your first valuation event"), ".  In ", React.createElement("i", null, "percentage"), " terms" + " " +
          "you were diluted, but in ", React.createElement("i", null, "value"), " terms you went from nothing to actual value! (At least on paper.)"
        )
      )
    );
  }
});


/** WEBPACK FOOTER **
 ** /Users/dlopuch/developer/projects-venture-dealr/~/jsx-loader?harmony!./views/scrollSpyContents/SeedValue.jsx
 **/